import { SxProps, Theme, styled } from '@mui/material';
import { Link } from 'react-router-dom';

export const appBarSx: SxProps<Theme> = {
  mb: 0,
};

export const leftNavSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 3,
};

export const navItemsContainerSx: SxProps<Theme> = {
  display: 'flex',
  gap: 0,
  height: '100%',
};

export const spacerSx: SxProps<Theme> = {
  flexGrow: 1,
};

export const rightNavSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 2,
};

export const StyledLogoLink = styled(Link)({
  textDecoration: 'none',
  display: 'flex',
  alignItems: 'center',
});

export const StyledLogoImage = styled('img')({
  height: '28px',
  width: 'auto',
  marginRight: '8px',
});
